import { Component, OnInit } from '@angular/core';

/**
 * service Files
 */
import { LoginService } from "../../services/auth/login/login.service";
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.less']
})
export class NavbarComponent implements OnInit {

  public username

  constructor(private LoginService: LoginService) { }

  ngOnInit() {

    let username:any = JSON.parse(localStorage.getItem("userDetails"))
    if(username != null){
      this.username = username.STAFF_NAME
    } 
  }

  async logout(){
  await this.LoginService.userLogOut()
  }

}
